import type { CartArticleType } from 'services/types';
import { formatPrice, type LocaleIso } from 'utils';
import { getArticlePriceDetails } from './getArticlePriceDetails';
import { formatArticleScale, getArticleScalePrice, isScalableArticle } from './getArticleScalePrice';

/** Formatted price view values for an article card; keeps the scale/fallback logic out of the JSX. */
export function getArticleCardPrices(article: CartArticleType, locale: LocaleIso) {
  const { unitPriceArticle, totalPriceArticle } = getArticlePriceDetails(article);
  const isScalable = isScalableArticle(article);
  const scalePrice = isScalable
    ? getArticleScalePrice(article.summaryPriceGross, article.summaryPriceGrossScaled)
    : null;

  return {
    isScalable,
    price: formatPrice(scalePrice?.scaledTotal ?? totalPriceArticle, locale) ?? '',
    unitPrice: formatPrice(unitPriceArticle, locale) ?? '',
    scale: formatArticleScale(scalePrice, locale)
  };
}
